import { jsxs as n, jsx as o } from "react/jsx-runtime";
import { Popover as p, Box as r, PopoverTrigger as s, PopoverContent as a, PopoverBody as d } from "@chakra-ui/react";
import { Button as h } from "../../forms/Button/Button.mjs";
import { IconButton as f } from "../../forms/Button/IconButton.mjs";
import "../../forms/Button/ButtonGroup.mjs";
import { Avatar as g } from "../../media/Avatar/Avatar.mjs";
import { ArrowRightFromBracketIcon as u } from "../../icons/componentIcons.mjs";
import { useGlobalHeaderv2DevContext as v } from "./useGlobalHeaderv2Context.mjs";
import { Tooltip as b } from "../../overlay/Tooltip/Tooltip.mjs";
const I = ({ onSignOutClick: t, userMenuBody: e, userName: i }) => {
  const { isUserMenuOpen: l, onUserMenuClose: m, onUserMenuToggle: c } = v();
  return /* @__PURE__ */ n(p, { placement: "bottom-end", gutter: 2, isOpen: l, onClose: m, children: [
    /* @__PURE__ */ o(b, { label: "My Profile", children: /* @__PURE__ */ o(r, { display: "inline-block", children: /* @__PURE__ */ o(s, { children: /* @__PURE__ */ o(
      f,
      {
        "aria-label": "My Profile",
        variant: "ghost",
        icon: /* @__PURE__ */ o(g, { size: "sm", name: i }),
        borderRadius: "full",
        onClick: c
      }
    ) }) }) }),
    /* @__PURE__ */ o(a, { children: /* @__PURE__ */ n(d, { children: [
      e && /* @__PURE__ */ o(r, { paddingBottom: 4, children: e }),
      /* @__PURE__ */ o(r, { textAlign: "right", children: /* @__PURE__ */ o(
        h,
        {
          variant: "ghost",
          leftIcon: /* @__PURE__ */ o(u, {}),
          onClick: t,
          children: "Sign Out"
        }
      ) })
    ] }) })
  ] });
};
export {
  I as UserMenu
};
